import { Pipe, PipeTransform } from '@angular/core';
import { MonitoringAlarm } from '../models/monitoring-alarm';

@Pipe({
  name: 'hasUnacknowledgedAlarms'
})
export class HasUnacknowledgedAlarmsPipe implements PipeTransform {

  transform(alarms: MonitoringAlarm[]): boolean {
    return alarms ? alarms.filter(alarm => !alarm.acknowledged).length > 0 : false;
  }

}
